import * as React from "react";
import { ITabProps, Tab } from "./Tab";
import { IActiveSectionProps } from "../";
import { IToolFrameProps } from "../ToolFrame/index";
import { IToolProps } from "./Tool";
import { NavigationTower } from "./NavigationTower";

export interface ISideMenuProps {
    activeSections: IActiveSectionProps[];
    activeTool: IToolFrameProps;
    bindToolToFrame: (
        moduleID: number,
        displayName: string,
        toolLookup: string,
        toolUrl: string,
    ) => void;
    openSection: (
        tools: IToolProps[],
        moduleID: number,
        displayName: string,
        toolLookup: string,
        toolUrl: string,
    ) => void;
    tabs: ITabProps[];
    toggleSection: (
        section: IActiveSectionProps,
        comparatorinator: (
            activeSections: IActiveSectionProps[],
        ) => IActiveSectionProps[],
    ) => void;
    updateSection: (section: IActiveSectionProps) => void;
}

export const SideMenu: React.FunctionComponent<ISideMenuProps> = (
    props,
): React.ReactElement => {
    const tabList: React.ReactNode[] = [];

    // Used to check if the tab is the last tab in the list.
    let isDivider = false;

    for (let i = 0; i < props.tabs.length; i++) {
        // All tabs with display order < 1000 are in the 'first half' The last element of the first half will have flex-grow: 1 set on it
        isDivider =
            typeof props.tabs[i + 1] !== `undefined` &&
            props.tabs[i + 1].displayOrder >= 1000 &&
            props.tabs[i].displayOrder < 1000;
        tabList.push(
            <Tab
                activeSections={props.activeSections}
                activeTool={props.activeTool}
                bindToolToFrame={props.bindToolToFrame}
                isDivider={isDivider}
                key={props.tabs[i].id}
                openSection={props.openSection}
                toggleSection={props.toggleSection}
                updateSection={props.updateSection}
                {...props.tabs[i]}
            />,
        );
    }

    const towerComponents: React.ReactNode[] = [];

    // For each of the active sections
    for (let i = 0; i < props.activeSections.length; i++) {
        // Check if it needs to add a component to the tower.
        if (props.activeSections[i].tower) {
            // If so, get it's component and add it to the list.
            towerComponents.push(props.activeSections[i].tower.bindComponent);
        }
    }
    // Put the elements together in one element.
    const towerElement: React.ReactNode = (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <React.Fragment>{towerComponents}</React.Fragment>
    );

    return (
        <React.Fragment>
            <div className={`sidemenu-toolbar`}>{tabList}</div>
            <NavigationTower bindComponent={towerElement} />
        </React.Fragment>
    );
};
